
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { GridsterModule } from 'angular-gridster2';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessagesModule } from 'primeng/messages';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MessageModule } from 'primeng/message';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { AccordionModule } from 'primeng/accordion';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { MeterGroupModule } from 'primeng/metergroup';
import { CalendarLocaleDirective } from '@app/core/directives/calendar.directive';

import { ByteFormatterPipe } from '@app/core/pipes/byte-formatter.pipe';
import { BakInputTypePipe } from '@app/core/pipes/bak-input-type.pipe';
import { IntToHexPipe } from '@app/core/pipes/int-to-hex.pipe';
import { UserRolePipe } from '@app/core/pipes/user-role.pipe';
import { MessageItemFormatterPipe } from '@app/core/pipes/message-item-formatter.pipe';
import { MessageTypeFormatterPipe } from '@app/core/pipes/message-type-formatter.pipe';
import { ImportSolutionFormatterPipe } from '@app/core/pipes/import-solution-formatter.pipe';
import { ImportMatchClassFormatterPipe } from '@app/core/pipes/import-match-class-formatter.pipe';
import { MessageLevelFormatterPipe } from '@app/core/pipes/message-level-formatter.pipe';

import { LayoutImportSolutionComponent } from '@app/shared/components/layout-import-solution/layout-import-solution.component';
import { MessageSpecificInfoComponent } from '@app/shared/components/message-specific-info/message-specific-info.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AutoCompleteModule,
        DropdownModule,
        TableModule,
        ButtonModule
    ],
    declarations: [
        CalendarLocaleDirective,
        ByteFormatterPipe,
        BakInputTypePipe,
        IntToHexPipe,
        UserRolePipe,
        MessageItemFormatterPipe,
        MessageTypeFormatterPipe,
        ImportSolutionFormatterPipe,
        ImportMatchClassFormatterPipe,
        MessageLevelFormatterPipe,
        LayoutImportSolutionComponent,
        MessageSpecificInfoComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmDialogModule,
        TableModule,
        DialogModule,
        PasswordModule,
        InputTextModule,
        MessageModule,
        InputTextareaModule,
        CheckboxModule,
        AutoCompleteModule,
        MessagesModule,
        SelectButtonModule,
        CalendarModule,
        DropdownModule,
        MeterGroupModule,
        IconFieldModule,
        InputIconModule,
        InputMaskModule,
        FileUploadModule,
        MultiSelectModule,
        ToggleButtonModule,
        ButtonModule,
        TooltipModule,
        DynamicDialogModule,
        FieldsetModule,
        OrganizationChartModule,
        AccordionModule,
        ToolbarModule,
        ColorPickerModule,
        GridsterModule,
        ContextMenuModule,
        CalendarLocaleDirective,
        ByteFormatterPipe,
        BakInputTypePipe,
        IntToHexPipe,
        UserRolePipe,
        MessageItemFormatterPipe,
        MessageTypeFormatterPipe,
        ImportMatchClassFormatterPipe,
        ImportSolutionFormatterPipe,
        MessageLevelFormatterPipe,
        MessageSpecificInfoComponent
    ]
})
export class SharedModule { }
